module.exports = __webpack_public_path__ + "static/img/3.0bd9c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-construccion/3.png
// module id = UWRy
// module chunks = 0